<template>
    <v-progress-circular
        indeterminate
        :size="100"
        :width="15"
        color="#0e2f5a"
    ></v-progress-circular>
</template>
